<template>
  <div>
    <el-table :data="tableData" stripe>
      <el-table-column prop="name" label="参数名">
      </el-table-column>
      <el-table-column prop="remark" label="备注说明">
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template scope="scope">
          <div>
            <router-link :to="{name: 'dictionaryEdit', params: { id: scope.row.id }}" class="btn-link edit-btn">编辑</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <div class="block pages">
        <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :page-size="pageSetting.limit" :current-page="pageSetting.page" :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import http from '../../../../assets/js/http'
export default {
  data() {
    return {
      tableData: [],
      pageSetting: {
        keyword: '',
        limit: 15,
        page: 1
      },
      dataCount: 0
    }
  },
  methods: {
    handleCurrentChange(page) {
      this.pageSetting.page = page
    },
    getTableData() {
      // 访问接口获取数据
      let inputData = {
        params: {
          limit: this.pageSetting.limit,
          page: this.pageSetting.page,
          keyword: this.pageSetting.keyword
        }
      }
      this.apiGet(`pd/users`, inputData).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.dataCount = res.data.dataCount
        }
      })
    },
    init() {
      this.getTableData()
    }
  },
  created() {
    this.init()
  },
  mixins: [http]
}
</script>





// WEBPACK FOOTER //
// list.vue?22ca9685